import { useEffect } from "react";
import Hero from "../sections/Hero";
import Erkenntnis from "../sections/Erkenntnis";
import Arbeitsweise from "../sections/Arbeitsweise";
import Belege from "../sections/Belege";
import Analyse from "../sections/Analyse";
import Passt from "../sections/Passt";
import Faq from "../sections/Faq";
import UeberPatrick from "../sections/UeberPatrick";
import Formular from "../sections/Formular";
import { track } from "../lib/tracking";

export default function LandingPage() {
  useEffect(() => {
    track("PageView");
  }, []);

  return (
    <main className="bg-white">
      <Hero />
      <Erkenntnis />
      <Arbeitsweise />
      <Belege />
      <Analyse />
      <Passt />
      <Faq />
      <UeberPatrick />
      <Formular />
    </main>
  );
}
